<script setup lang="ts">
import { RouterView } from 'vue-router'
import { isMobileOnly } from 'mobile-device-detect'
import { useRouter } from 'vue-router'
import { onMounted, ref, watch } from 'vue'
import { ModalsContainer } from 'vue-final-modal'
import { parseToken } from '@/utils/Utils'
import { meInfo } from '@/services/mentor/Mentor'
const mobileDetect = ref(isMobileOnly)
const router = useRouter()
const isLoading = ref(false)
watch(mobileDetect, () => {
  console.log(mobileDetect)
})
const checkToken = async () => {
  try {
    isLoading.value = true
    let userType = localStorage.getItem('userType')
    const isHaveToken = parseToken()
    if (isHaveToken && userType === 'Coach') {
      let responseStudent = await meInfo()
      localStorage.setItem('userType', responseStudent.data.userType)
      localStorage.setItem('userStatus', responseStudent.data.status)
    }
  } catch (e) {
    console.log(e)
  } finally {
    isLoading.value = false
  }
}

onMounted(async () => {
  const isDark = localStorage.getItem('theme') === 'dark'
  if (isDark) {
    localStorage.setItem('theme', 'light')
  }
  if (isMobileOnly) {
    await router.push('/mobile-detect')
    return
  }
  await checkToken()
})
</script>

<template>
  <ModalsContainer />
  <div
    v-if="isLoading"
    class="fixed flex justify-center items-center top-0 left-0 h-full w-full bg-white z-50"
  >
    <div
      class="border-gray-200 h-10 w-10 animate-spin mx-auto rounded-full border-4 border-t-purple-400"
    />
  </div>
  <RouterView v-if="!isLoading" />
</template>
